/* global rp$, window, document */
'use strict';

const getGarageStore = () => import(
	'public/js/components/garage-store.js'
);

const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const utils = require('public/js/helpers/utils');

function getSelectedCar(garage) {
	if (!Array.isArray(garage) || garage.length === 0) {
		return null;
	}
	return garage.find((car) => car?.selected) || null;
}

function updateVehicleSidebar(selectedCar) {
	document.querySelectorAll('.vehicle-sidebar-module').forEach((sidebarModule) => {
		if (!(sidebarModule instanceof HTMLElement)) {
			return;
		}

		const selectedVehicleContainer = sidebarModule.querySelector('[data-vp-vehicle-sidebar-selected]');
		const vehiclePickerContainer = sidebarModule.querySelector('[data-vp-vehicle-sidebar-picker]');

		if (!selectedVehicleContainer || !vehiclePickerContainer) {
			return;
		}

		if (selectedCar) {
			selectedVehicleContainer.style.display = '';
			vehiclePickerContainer.style.display = 'none';
		} else {
			selectedVehicleContainer.style.display = 'none';
			vehiclePickerContainer.style.display = '';
		}
	});
}

function handleGarageUpdated(eventOrGarage, maybeGarage, ...rest) {
	const garage = utils.normalizeEventPayloadArgs(eventOrGarage, maybeGarage, rest);
	const selectedCar = getSelectedCar(garage);
	updateVehicleSidebar(selectedCar);
}

function attachEvents() {
	getGarageStore().then((module) => {
		const rp_garage_store = module?.handleGarageData ?? null;
		if (!rp_garage_store || typeof rp_garage_store.getGarageData !== 'function') {
			return;
		}

		rp$(document)
			.off('garageUpdated.vehicleSidebar')
			.on('garageUpdated.vehicleSidebar', handleGarageUpdated);

		const sidebarModule = document.querySelector('.vehicle-sidebar-module');
		const isVehicleSpecificPage = utils.isTruthyDataValue(sidebarModule?.dataset?.isVehicleSpecificPage);
		const garage = rp_garage_store.getGarageData(isVehicleSpecificPage);
		if (garage) {
			handleGarageUpdated(garage);
		}
	}).catch(() => {
		// ignore
	});
}

runScriptOnReady('vehicle_sidebar', attachEvents);
